module.exports = __webpack_public_path__ + "img/search-mobile-massage-2020.e2a31152.jpg";